var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"passwordProfile__avatar",style:(_vm.avatarStyle)},[_vm._v(" "+_vm._s(_vm.firstLetter)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }